import { useSelector } from 'react-redux'
import { AllState } from '../../store'
import { ProjectRulesResponse } from '../../domain/value-object/ProjectRulesVO'
import { featureFlagService } from '../../utils/feature-flag'

export const useProjectRules = (): ProjectRulesResponse | undefined => {
  return useSelector((state: AllState) => state.projectRules.rules)
}

/**
 * フラグON かつ ルールがSINGLE のときtrue を返す
 * タスク行（チケット含む）のスプリント選択を単一に制限する
 */
export const useIsTaskSprintRuleSingle = (): boolean => {
  const rules = useProjectRules()
  const isMultiSelectEnabled = featureFlagService.isEnabled(
    'sprints-multi-select'
  )
  return isMultiSelectEnabled && rules?.sprintTaskAssociationMode === 'SINGLE'
}
